const getCorrectNumber = (precision) => Number(`0.${new Array(precision).join('0')}1`);

export const MathUtils = {
  clamp: (value, lowerBound, upperBound) => {
    if (value < lowerBound) {
      return lowerBound;
    }
    if (value > upperBound) {
      return upperBound;
    }
    return value;
  },
  floor: (value, precision) => {
    const multiplier = Math.pow(10, precision || 0);
    const correctValue = getCorrectNumber(precision);
    return Math.floor(value * multiplier + correctValue) / multiplier;
  },
  round: (value, precision) => {
    const multiplier = Math.pow(10, precision || 0);
    return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
  }
}